/**
 * Logout callback registered by App (which has access to Auth0's logout).
 * Used by the API response interceptor when a 403 "Admin access required" is received,
 * so we can log the user out from outside the React tree.
 */
let logoutCallback = null;

export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

export const getLogoutCallback = () => logoutCallback;
